<template>
  <div>
    <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
      <form @submit.prevent="submit" id="settings_form">
        <div class="d-flex align-items-center px-3">
          <div class="ml-auto">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 0 24 24"
                width="24px"
                fill="#00bea5"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                  d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
              />
            </svg>
            <span class="pr-2">اعلانات پیامکی</span>
          </div>
          <div>
            <button
              type="submit"
              class="btn btn-success px-4"
              style="border-radius: 10px"
              id="submit_btn"
              :disabled="form_submit_loading"
            >
              <span v-if="form_submit_loading">
                <span class="pl-2">در حال انجام</span>
                <span
                  class="spinner-border spinner-border-sm p-2"
                  role="status"
                ></span>
              </span>
              <span v-else>ثبت تغییرات</span>
            </button>
          </div>
        </div>
        <hr />

        <div class="alert alert-success m-3" style="border-radius: 10px">
          <span
            >پیام های اطلاع رسانی را که تمایل به دریافت آنها دارید، انتخاب
            کنید.</span
          >
        </div>

        <div class="p-3">
          <div class="form-group form-check">
            <label class="switch">
              <input
                type="checkbox"
                id="sms_change_password"
                v-model="form_data.send_change_password"
              />
              <span class="slider round"></span>
            </label>
            <label
              for="sms_change_password"
              class="btn m-0 p-0 text-secondary form-check-label pr-4"
              >تغییر کلمه عبور</label
            >
          </div>
          <div class="form-group form-check">
            <label class="switch">
              <input
                type="checkbox"
                id="sms_ticket_reply"
                v-model="form_data.send_ticket_reply"
              />
              <span class="slider round"></span>
            </label>
            <label
              for="sms_ticket_reply"
              class="btn m-0 p-0 text-secondary form-check-label pr-4"
              >پاسخ به تیکت</label
            >
          </div>
          <div class="form-group form-check">
            <label class="switch">
              <input
                type="checkbox"
                id="sms_gateway_status_change"
                v-model="form_data.send_terminal_change_status"
              />
              <span class="slider round"></span>
            </label>
            <label
              for="sms_gateway_status_change"
              class="btn m-0 p-0 text-secondary form-check-label pr-4"
              >تغییر وضعیت درگاه</label
            >
          </div>
          <div class="form-group form-check">
            <label class="switch">
              <input
                type="checkbox"
                id="sms_successful_transaction"
                v-model="form_data.send_successful_transaction"
              />
              <span class="slider round"></span>
            </label>
            <label
              for="sms_successful_transaction"
              class="btn m-0 p-0 text-secondary form-check-label pr-4"
              >تراکنش موفق</label
            >
          </div>
          <div class="form-group form-check">
            <label class="switch">
              <input
                type="checkbox"
                id="sms_settlement"
                v-model="form_data.send_settlement"
              />
              <span class="slider round"></span>
            </label>
            <label
              for="sms_settlement"
              class="btn m-0 p-0 text-secondary form-check-label pr-4"
              >تسویه حساب درگاه</label
            >
          </div>
        </div>
      </form>
    </div>

    <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
      <form @submit.prevent="set_sms_wallet" id="settings_sms_wallet_form">
        <div class="d-flex align-items-center px-3">
          <div class="ml-auto">
            <span>کیف پول پیامکی</span>
          </div>
          <div>
            <span>تعداد پیامک قابل ارسال</span>&nbsp;
            <span>{{ form_data.sms_count_can_send }}</span>
          </div>
        </div>
        <hr />
        <div class="p-3">
          <div class="d-flex align-items-center">
            <div class="form-group w-50 px-3">
              <label for="sms_charge">افزایش اعتبار پیامک</label>
              <input
                type="number"
                id="sms_charge"
                class="form-control"
                v-model="sms_number"
                placeholder="تعداد پیامک"
                @keyup="setRechargePrice()"
                @change="setRechargePrice()"
              />
              <small class="form-text text-muted"
                >حداقل مقدار افزایش اعتبار 10,000 ریال می باشد.</small
              >
            </div>
            <input
              name="recharge_price"
              type="number"
              :value="recharge_price"
              style="display: none"
              id="recharge_price"
            />
            <div class="mr-auto">
              <span class="text-success px-2"
                >قابل پرداخت
                <span>
                  {{ recharge_price_currency_format + " " + $t("label.rial") }}
                </span>
              </span>
              <button
                type="submit"
                class="btn btn-success px-4"
                style="border-radius: 10px"
                id="submit_btn_sms_wallet"
                :disabled="wallet_form_submit_loading"
              >
                <span v-if="wallet_form_submit_loading">
                  <span class="pl-2">در حال انجام</span>
                  <span
                    class="spinner-border spinner-border-sm p-2"
                    role="status"
                  ></span>
                </span>
                <span v-else>پرداخت</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {ApiUrl, notificationSmsService} from "@/common/core.service";
import { mapGetters } from "vuex";
import { i18n } from "@/plugins/i18n";
import {BASE_PATH} from "@/common/config";
export default {
  name: "sms",
  computed: {
    ...mapGetters("notificationSms", ["form_data"]),
    ...mapGetters("notificationSms", ["getRechargePriceStatus"]),
  },
  data() {
    return {
      sms_number: '',
      recharge_price: 0,
      recharge_price_currency_format: 0,
      form_submit_loading: false,
      wallet_form_submit_loading: false,
    };
  },

  methods: {
    submit(e) {
      let form = $("#settings_form");
      let btn = $("#submit_btn");

      this.form_submit_loading = true;

      let params = this.$store.getters["notificationSms/form_data"];

      notificationSmsService
        .update(params)
        .then((response) => {
          this.showMsg(form, "success", response.data.message);
        })
        .catch(({ response }) => {
          this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {
          this.form_submit_loading = false;
        });
    },
    set_sms_wallet(e) {
      let form = $("#settings_sms_wallet_form");
      let btn = $("#submit_btn_sms_wallet");

      form.validate({
        rules: {
          recharge_price: {
            required: true,
            min: 10000,
          },
        },
      });
      if (!form.valid()) {
        return;
      }

      this.wallet_form_submit_loading = true;

      let params = {
        recharge_price: $("#recharge_price").val(),
      };
      notificationSmsService
        .updateSmsWallet(params)
        .then((response) => {
          location.replace(response.data.data.redirect_url);
        })
       .catch(({ response }) => {
          this.showMsg(form, "danger", i18n.t("message.an_error_accord"));
        })
        .finally(() => {
          this.wallet_form_submit_loading = false;
        });
    },
    increment() {
      this.$store.dispatch("notificationSms/increment");
    },
    setRechargePrice() {
      if (this.sms_number == '') {
        this.recharge_price = 0;
      } else {
        this.recharge_price = this.sms_number * this.form_data.sms_price;
      }
      
      this.recharge_price_currency_format = this.moneyFormat(
        this.recharge_price
      );
    },
    moneyFormat(price) {
      const pieces = parseFloat(price).toFixed(0).split("");
      let ii = pieces.length;
      while ((ii -= 3) > 0) {
        pieces.splice(ii, 0, ",");
      }
      return pieces.join("");
    },
  },
};
</script>

<style scoped>
</style>